import { useAppContext } from "@/hooks/use-app-context";
import { Suspense } from "react";

export function HomePage() {
  const { current } = useAppContext();
  const Component = current.step.component;

  return (
    <div>
      <Suspense fallback={<div></div>}>
        <Component />
      </Suspense>
    </div>
  );
}
